import {
    ACTIVITIES,
    AGENDA,
    COMPANIES,
    CONTACTS,
    OPPORTUNITIES,
    SALESORDERS,
    TASKS,
} from 'constants/Entities';
import Context from 'managers/Context';

import ActivityModel from 'models/ActivityModel';
import AgendaModel from 'models/AgendaModel';
import CompanyModel from 'models/CompanyModel';
import ContactModel from 'models/ContactModel';
import OpportunityModel from 'models/OpportunityModel';
import SalesOrdersModel from 'models/SalesOrdersModel';
import TaskModel from 'models/TaskModel';
import { parseDateStringToDate } from 'utils/dates';

const STANDARD_DATE_TYPES = new Set(['date', 'dateTime', 'datetime']);

const normalizeStandardDateFields = (entity, data) => {
    if (!entity?.extraFieldName || !data || typeof data !== 'object') {
        return data;
    }

    const standardFieldsSchema =
        Context.store.getState()?.config?.standardFieldsSchemaMap?.[entity.extraFieldName];

    if (!standardFieldsSchema) {
        return data;
    }

    return Object.entries(standardFieldsSchema).reduce(
        (normalizedData, [fieldId, fieldConfig]) => {
            if (
                STANDARD_DATE_TYPES.has(fieldConfig?.dataType) &&
                typeof normalizedData[fieldId] === 'string'
            ) {
                normalizedData[fieldId] = parseDateStringToDate(normalizedData[fieldId]);
            }

            return normalizedData;
        },
        { ...data },
    );
};

const createCopilotTransformer = (entity, transformer) => (data) =>
    normalizeStandardDateFields(entity, transformer(data));

/**
 * Copilot data transformers by entity type
 * Maps entity types to their Model's copilot transformation methods
 * Methods are bound to preserve 'this' context when called as standalone functions
 */
export const COPILOT_TRANSFORMERS = {
    [ACTIVITIES.trueName]: createCopilotTransformer(
        ACTIVITIES,
        ActivityModel.toCrudFromCopilot.bind(ActivityModel),
    ),
    [AGENDA.trueName]: createCopilotTransformer(
        AGENDA,
        AgendaModel.toCrudFromCopilot.bind(AgendaModel),
    ),
    [COMPANIES.trueName]: createCopilotTransformer(
        COMPANIES,
        CompanyModel.toCrudFromCopilot.bind(CompanyModel),
    ),
    [CONTACTS.trueName]: createCopilotTransformer(
        CONTACTS,
        ContactModel.toCrudFromCopilot.bind(ContactModel),
    ),
    [OPPORTUNITIES.trueName]: createCopilotTransformer(
        OPPORTUNITIES,
        OpportunityModel.toCrudFromCopilot.bind(OpportunityModel),
    ),
    [SALESORDERS.trueName]: createCopilotTransformer(
        SALESORDERS,
        SalesOrdersModel.toCrudFromCopilot.bind(SalesOrdersModel),
    ),
    [TASKS.trueName]: createCopilotTransformer(TASKS, TaskModel.toCrudFromCopilot.bind(TaskModel)),
};
